var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExtranet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 64L128 192v384c0 212.1 171.9 384 384 384s384-171.9 384-384V192L512 64zm312 512c0 172.3-139.7 312-312 312S200 748.3 200 576V246l312-110 312 110v330z",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M378.4 475.1a35.91 35.91 0 00-50.9 0 35.91 35.91 0 000 50.9l129.4 129.4 2.1 2.1a33.98 33.98 0 0048.1 0L730.6 434a33.98 33.98 0 000-48.1l-2.8-2.8a33.98 33.98 0 00-48.1 0L483 579.7 378.4 475.1z",
    stroke: "none"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyBzdHJva2U9ImN1cnJlbnRDb2xvciIgZmlsbD0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjAiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGhlaWdodD0iMWVtIiB3aWR0aD0iMWVtIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPg0KICAgIDxwYXRoIGQ9Ik01MTIgNjRMMTI4IDE5MnYzODRjMCAyMTIuMSAxNzEuOSAzODQgMzg0IDM4NHMzODQtMTcxLjkgMzg0LTM4NFYxOTJMNTEyIDY0em0zMTIgNTEyYzAgMTcyLjMtMTM5LjcgMzEyLTMxMiAzMTJTMjAwIDc0OC4zIDIwMCA1NzZWMjQ2bDMxMi0xMTAgMzEyIDExMHYzMzB6Ij48L3BhdGg+DQogICAgPHBhdGggZD0iTTM3OC40IDQ3NS4xYTM1LjkxIDM1LjkxIDAgMCAwLTUwLjkgMCAzNS45MSAzNS45MSAwIDAgMCAwIDUwLjlsMTI5LjQgMTI5LjQgMi4xIDIuMWEzMy45OCAzMy45OCAwIDAgMCA0OC4xIDBMNzMwLjYgNDM0YTMzLjk4IDMzLjk4IDAgMCAwIDAtNDguMWwtMi44LTIuOGEzMy45OCAzMy45OCAwIDAgMC00OC4xIDBMNDgzIDU3OS43IDM3OC40IDQ3NS4xeiI+PC9wYXRoPg0KPC9zdmc+";
export { SvgExtranet as ReactComponent };